import { MouseEventHandler } from 'react';
import Icon from '@ant-design/icons';

interface IProps {
    className?: string;
    onClick?: MouseEventHandler<HTMLSpanElement>;
}

export const SwiperSwitchLeftSvg = (props: IProps) => (
    <Icon
        {...props}
        component={() => (
            <svg width="11" height="18" viewBox="0 0 11 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 16L2 9.36842L9 2" stroke="#9655FF" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M9 16L2 9.36842L9 2" stroke="#9655FF" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )}
        onDoubleClick={ev => ev.stopPropagation()}
    />
);

export const SwiperSwitchRightSvg = (props: IProps) => (
    <Icon
        {...props}
        component={() => (
            <svg width="11" height="18" viewBox="0 0 11 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2 16L9 9.36842L2 2" stroke="#9655FF" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M2 16L9 9.36842L2 2" stroke="#9655FF" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )}
        onDoubleClick={ev => ev.stopPropagation()}
    />
);

export const SwiperAnswerTitleIconSvg = (props: IProps) => (
    <Icon
        {...props}
        component={() => (
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.13998 18.5C7.29383 18.5 7.44538 18.4594 7.57627 18.3804L10.9311 16.4029H16.557C17.7672 16.4007 18.7477 15.4368 18.75 14.2472V5.65576C18.7477 4.46614 17.7672 3.50226 16.557 3.5H3.44295C2.23281 3.50226 1.2523 4.46614 1.25 5.65576V14.2472C1.2523 15.4368 2.23281 16.4007 3.44295 16.4029H5.68413L6.35465 17.9853C6.44879 18.2088 6.63938 18.3826 6.87361 18.4571C6.96086 18.4865 7.05042 18.5 7.13998 18.5Z"
                    stroke="#9D8AFE"
                    strokeWidth="1.25"
                />
                <path
                    d="M5.01953 11.5449C4.31885 11.5449 3.75 10.9761 3.75 10.2754C3.75 9.57471 4.31885 9.00586 5.01953 9.00586C5.72021 9.00586 6.28906 9.57471 6.28906 10.2754C6.28906 10.9761 5.72021 11.5449 5.01953 11.5449Z"
                    fill="#9D8AFE"
                />
                <path
                    d="M9.79492 11.5449C9.09424 11.5449 8.52539 10.9761 8.52539 10.2754C8.52539 9.57471 9.09424 9.00586 9.79492 9.00586C10.4956 9.00586 11.0645 9.57471 11.0645 10.2754C11.0645 10.9761 10.4956 11.5449 9.79492 11.5449Z"
                    fill="#9D8AFE"
                />
                <path
                    d="M14.5703 11.5449C13.8696 11.5449 13.3008 10.9761 13.3008 10.2754C13.3008 9.57471 13.8672 9.00586 14.5703 9.00586C15.271 9.00586 15.8398 9.57471 15.8398 10.2754C15.8398 10.9761 15.271 11.5449 14.5703 11.5449Z"
                    fill="#9D8AFE"
                />
            </svg>
        )}
    />
);

export const EveryoneIsAskListItemIconSvg = (props: IProps) => (
    <Icon
        {...props}
        component={() => (
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g filter="url(#filter0_ii_242_3623)">
                    <path
                        d="M1.11133 7.77799C1.11133 4.0961 4.0961 1.11133 7.77799 1.11133H12.2224C15.9043 1.11133 18.8891 4.0961 18.8891 7.77799V16.6669C18.8891 17.8942 17.8942 18.8891 16.6669 18.8891H7.77799C4.0961 18.8891 1.11133 15.9043 1.11133 12.2224V7.77799Z"
                        fill="url(#paint0_linear_242_3623)"
                    />
                </g>
                <path
                    d="M7.50033 5.73145C7.46329 5.73145 7.44477 5.80552 7.44477 5.95367V7.17589C7.44477 7.32404 7.46329 7.39811 7.50033 7.39811H5.16699C5.20403 7.39811 5.22255 7.32404 5.22255 7.17589V5.95367C5.22255 5.80552 5.20403 5.73145 5.16699 5.73145H7.50033ZM14.667 12.9981C14.667 13.65 14.5892 14.1314 14.4337 14.4426C14.2855 14.7611 14.0114 14.9796 13.6114 15.0981C13.2114 15.224 12.6003 15.287 11.7781 15.287C11.63 15.287 11.5559 15.3055 11.5559 15.3426V13.6759C11.5559 13.7129 11.63 13.7314 11.7781 13.7314C12.1485 13.7314 12.4077 13.6796 12.5559 13.5759C12.704 13.4722 12.7781 13.2648 12.7781 12.9537V7.50922H8.22255C8.0744 7.50922 8.00033 7.52774 8.00033 7.56478V5.73145C8.00033 5.76848 8.0744 5.787 8.22255 5.787H14.667V12.9981ZM7.22255 7.89811C7.18551 7.89811 7.16699 7.97219 7.16699 8.12033V15.0648C7.16699 15.2129 7.18551 15.287 7.22255 15.287H5.2781C5.31514 15.287 5.33366 15.2129 5.33366 15.0648V8.12033C5.33366 7.97219 5.31514 7.89811 5.2781 7.89811H7.22255ZM12.167 13.1203H7.83366V8.34256H12.167V13.1203ZM10.5003 11.5648V9.89811H9.50033V11.5648H10.5003Z"
                    fill="white"
                />
                <defs>
                    <filter
                        id="filter0_ii_242_3623"
                        x="-2.88867"
                        y="-2.88867"
                        width="21.7773"
                        height="25.7773"
                        filterUnits="userSpaceOnUse"
                        colorInterpolationFilters="sRGB"
                    >
                        <feFlood floodOpacity="0" result="BackgroundImageFix" />
                        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                        <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                        />
                        <feOffset dy="4" />
                        <feGaussianBlur stdDeviation="2" />
                        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                        <feColorMatrix type="matrix" values="0 0 0 0 0.920741 0 0 0 0 1 0 0 0 0 0.405555 0 0 0 0.25 0" />
                        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_242_3623" />
                        <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                        />
                        <feOffset dx="-4" dy="-4" />
                        <feGaussianBlur stdDeviation="2" />
                        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                        <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 0.67875 0 0 0 0 0.286111 0 0 0 1 0" />
                        <feBlend mode="normal" in2="effect1_innerShadow_242_3623" result="effect2_innerShadow_242_3623" />
                    </filter>
                    <linearGradient
                        id="paint0_linear_242_3623"
                        x1="0.0316531"
                        y1="1.11133"
                        x2="18.8891"
                        y2="17.6727"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stopColor="#FFBA61" />
                        <stop offset="1" stopColor="#FCD48B" />
                    </linearGradient>
                </defs>
            </svg>
        )}
    />
);

export const LoadMoreIconSvg = (props: IProps) => (
    <Icon
        {...props}
        component={() => (
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9.2389 2.96192C9.23888 3.0893 9.26395 3.21544 9.31269 3.33312C9.36142 3.45081 9.43286 3.55774 9.52292 3.64782C9.61298 3.7379 9.71991 3.80935 9.83759 3.8581C9.95527 3.90685 10.0814 3.93194 10.2088 3.93194C10.3362 3.93194 10.4623 3.90685 10.58 3.8581C10.6976 3.80935 10.8046 3.7379 10.8946 3.64782C10.9847 3.55774 11.0561 3.45081 11.1049 3.33312C11.1536 3.21544 11.1787 3.0893 11.1787 2.96192C11.1786 2.70472 11.0764 2.45806 10.8945 2.27621C10.7126 2.09435 10.466 1.99219 10.2088 1.99219C9.95157 1.99219 9.7049 2.09435 9.52302 2.27621C9.34114 2.45806 9.23893 2.70472 9.2389 2.96192ZM10.2088 11.2085C10.3363 11.2085 10.4625 11.1834 10.5802 11.1345C10.698 11.0857 10.805 11.0142 10.895 10.924C10.9851 10.8338 11.0565 10.7267 11.1052 10.6089C11.1539 10.491 11.1788 10.3648 11.1787 10.2373V6.84273C11.1787 6.71536 11.1536 6.58922 11.1049 6.47154C11.0561 6.35385 10.9847 6.24691 10.8946 6.15684C10.8046 6.06676 10.6976 5.99531 10.58 5.94656C10.4623 5.89781 10.3362 5.87272 10.2088 5.87272C10.0814 5.87272 9.95527 5.89781 9.83759 5.94656C9.71991 5.99531 9.61298 6.06676 9.52292 6.15684C9.43286 6.24691 9.36142 6.35385 9.31269 6.47154C9.26395 6.58922 9.23888 6.71536 9.2389 6.84273V10.2373C9.2389 10.7731 9.673 11.2085 10.2088 11.2085ZM9.68342 18.8019C9.75264 18.8675 9.83606 18.9162 9.92718 18.9443C10.0183 18.9723 10.1147 18.9789 10.2088 18.9636C10.3029 18.9789 10.3992 18.9723 10.4904 18.9443C10.5815 18.9162 10.6649 18.8675 10.7341 18.8019L16.835 12.6229C17.1139 12.3387 17.0305 11.7951 16.6485 11.4079C16.2666 11.0208 15.7295 10.936 15.4492 11.2189L10.2088 16.5285L4.96831 11.2189C4.68934 10.936 4.15226 11.0195 3.769 11.4079C3.38705 11.7951 3.30362 12.3387 3.58389 12.6216L9.68342 18.8019Z"
                    fill="white"
                />
            </svg>
        )}
    />
);

export const TabMoreIconSvg = (props: IProps) => (
    <Icon
        {...props}
        component={() => (
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11 14L15.7368 19L21 14" stroke="#9655FF" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )}
    />
);
